import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b23eba32"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增车辆类型")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "状态：", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("正常")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("停用")
const _hoisted_6 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"min-width":"50px"} }, "搜索：", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_9 = {
  key: 2,
  class: "btn_box"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("编辑")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_ImageView = _resolveComponent("ImageView")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_CarTypeSet = _resolveComponent("CarTypeSet")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, {
      title: "车辆类型管理",
      style: {"margin-bottom":"16px"},
      bordered: ""
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setVisible(true)))
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_row, { gutter: 16 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _hoisted_2,
                _createVNode(_component_a_select, {
                  value: _ctx.searches.status,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searches.status) = $event)),
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSearch('status', $event, $event))),
                  style: {"width":"100px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "" }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "1" }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "0" }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_a_input_search, {
                    value: _ctx.searches.name,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searches.name) = $event)),
                    "enter-button": "",
                    onSearch: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSearch('name', $event, $event))),
                    placeholder: "搜索"
                  }, null, 8, ["value"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { style: {"flex":"1"} }),
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "dashed",
                  onClick: _ctx.resetSearch
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      dataSource: _ctx.list,
      columns: _ctx.columns,
      loading: _ctx.loading,
      bordered: "",
      childrenColumnName: "a",
      pagination: false
    }, {
      bodyCell: _withCtx(({ column, text, record }) => [
        (column.key === 'image')
          ? (_openBlock(), _createBlock(_component_ImageView, {
              key: 0,
              "image-url": text
            }, null, 8, ["image-url"]))
          : _createCommentVNode("", true),
        (column.key === 'status')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(text ? '启用中' : '停用中'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'action')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_a_button, {
                size: "small",
                class: "btn",
                onClick: ($event: any) => (_ctx.setStatus(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(!record.status ? '启用' : '停用'), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_a_button, {
                size: "small",
                class: "btn",
                onClick: ($event: any) => (_ctx.setVisible(true, record))
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "columns", "loading"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.visible) = $event)),
      width: 700,
      title: _ctx.item ? '编辑司机' : '新增司机',
      footer: null,
      onCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setVisible(false )))
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_component_CarTypeSet, {
          "edit-item": _ctx.item,
          key: _ctx.item?.id || 'key',
          reset: _ctx.onClose
        }, null, 8, ["edit-item", "reset"]))
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ], 64))
}